/*
  Darlida bundle gift (21 Oct 2026)
  Keeps one free gift line in the cart while any physical product has
  window.D4Gift.min or more pieces in the cart, and removes it otherwise.
  22 Oct 2026: optional second level (D4Gift.v2 at D4Gift.min2 pieces) replaces the first gift.
  - Product pages (d4-product) call D4Gift.prep() to add the gift together with a bundle.
  - Any other cart change (drawer quantity, remove, upsells, apps) is watched through
    fetch / XHR and reconciled a moment later.
  - If the shopper removes the gift themselves, it is not re-added this session
    until they choose a bundle again on a product page.
  Config comes from layout/theme.liquid (Theme settings > Bundle gift).
*/
(function () {
  var G = window.D4Gift;
  if (!G || !G.v || G.ready) return;
  G.ready = true;

  var RT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var OF = window.fetch;
  var OFF = 'd4-gift-off', HAD = 'd4-gift-had';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null, busy = false, again = false;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function req(path, body) {
    var o = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return OF.call(window, RT + path, o).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'cart'); return d; });
    });
  }
  function getCart() { return req('cart.js'); }
  var LV = [{ v: G.v, min: G.min }];
  if (G.v2 && G.min2) LV.push({ v: G.v2, min: G.min2 });
  function isGift(id) { return LV.some(function (l) { return l.v == id; }); }
  function gifts(c) { return (c.items || []).filter(function (i) { return isGift(i.variant_id); }); }
  function levelFor(n) { var t = null; LV.forEach(function (l) { if (n >= l.min) t = l; }); return t; }
  function target(c) {
    var t = {}, k, best = 0;
    (c.items || []).forEach(function (i) {
      if (isGift(i.variant_id) || !i.requires_shipping) return;
      t[i.product_id] = (t[i.product_id] || 0) + i.quantity;
    });
    for (k in t) if (t[k] > best) best = t[k];
    return levelFor(best);
  }
  function qualifies(c) { return !!target(c); }
  G.qualifies = qualifies;

  function drawer() {
    var cd = document.querySelector('cart-drawer');
    return cd && cd.renderContents && cd.getSectionsToRender ? cd : null;
  }
  function withSections(body) {
    if (drawer()) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
    return body;
  }
  function refresh(d) {
    var cd = drawer();
    if (cd && d && d.sections) { try { if (window.D4Checkout && window.D4Checkout.renderDrawer) window.D4Checkout.renderDrawer(d.sections); else cd.renderContents(d, true); } catch (e) {} }
    var page = document.querySelector('cart-items');
    if (page && page.nodeName == 'CART-ITEMS' && page.onCartUpdate) { try { page.onCartUpdate(); } catch (e) {} }
  }

  /* Called by d4-product before it adds a bundle. Resolves to the item list, with the gift appended when needed. */
  G.prep = function (items, qty, physical) {
    var lv = physical ? levelFor(qty) : null;
    if (!lv) return Promise.resolve(items);
    ss(OFF, null);
    return getCart().then(function (c) {
      return gifts(c).some(function (i) { return i.variant_id == lv.v; }) ? items : items.concat([{ id: lv.v, quantity: 1 }]);
    }).catch(function () { return items; });
  };
  G.added = function () { ss(HAD, '1'); };

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (c) {
      var lv = target(c), g = gifts(c), q = !!lv, up = {}, keep = null, change = false;
      g.forEach(function (i) {
        if (q && i.variant_id == lv.v && !keep) { keep = i; if (i.quantity != 1) { up[i.key] = 1; change = true; } }
        else { up[i.key] = 0; change = true; }
      });
      var has = !!keep;
      if (ss(HAD) == '1' && !g.length && q) ss(OFF, '1'); /* the shopper removed it */
      if (!q) ss(OFF, null);
      if (change) {
        return req('cart/update.js', withSections({ updates: up })).then(function (d) {
          ss(HAD, has ? '1' : null);
          if (q && !has && ss(OFF) != '1') return req('cart/add.js', withSections({ items: [{ id: lv.v, quantity: 1 }] })).then(function (d2) { ss(HAD, '1'); refresh(d2); });
          refresh(d);
        });
      }
      if (q && !has && ss(OFF) != '1') {
        return req('cart/add.js', withSections({ items: [{ id: lv.v, quantity: 1 }] })).then(function (d) { ss(HAD, '1'); refresh(d); });
      }
      ss(HAD, has ? '1' : null);
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }
  G.bundleSelected = function (qty) { if (levelFor(qty)) ss(OFF, null); };
  G.pause = function () { G.checkoutPending = true; clearTimeout(timer); return new Promise(function (resolve) { (function wait() { if (busy) return setTimeout(wait, 40); resolve(); })(); }); };
  G.resume = function (confirmed) { G.checkoutPending = false; if (!confirmed) schedule(); };
  G.syncForCheckout = function (sections) {
    if (busy) return new Promise(function (resolve) { setTimeout(resolve, 50); }).then(function () { return G.syncForCheckout(sections); });
    return getCart().then(function (c) {
      var lv = target(c), g = gifts(c), up = {}, keep = null;
      g.forEach(function (i) {
        if (lv && i.variant_id == lv.v && !keep) { keep = i; if (i.quantity != 1) up[i.key] = 1; }
        else up[i.key] = 0;
      });
      var changed = Object.keys(up).length > 0;
      var update = changed ? req('cart/update.js', withSections({ updates: up })).then(function (d) { c = d; sections = d.sections; }) : Promise.resolve();
      return update.then(function () {
        if (lv && !keep && ss(OFF) != '1') { changed = true; return req('cart/add.js', withSections({ items: [{ id: lv.v, quantity: 1 }] })).then(function (d) { sections = d.sections; }); }
      }).then(function () { return changed ? getCart() : c; }).then(function (fresh) {
        var expected = target(fresh), actual = gifts(fresh);
        if (expected && ss(OFF) != '1' && (actual.length != 1 || actual[0].variant_id != expected.v || actual[0].quantity != 1)) throw new Error('The bundle gift could not be confirmed.');
        ss(HAD, actual.length ? '1' : null); fresh.sections = sections; return fresh;
      });
    });
  };
  function schedule() { clearTimeout(timer); if (!G.checkoutPending) timer = setTimeout(run, 450); }
  G.check = schedule;

  /* Watch cart changes made by the theme, upsells and apps. Our own requests use the original fetch. */
  window.fetch = function (input) {
    var p = OF.apply(window, arguments);
    try {
      var u = typeof input == 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(String(u).split('#')[0])) p.then(function (r) { if (r && r.ok) schedule(); }, function () {});
    } catch (e) {}
    return p;
  };
  if (window.XMLHttpRequest) {
    var XO = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (CART_RE.test(String(u).split('#')[0])) this.addEventListener('load', function () { if (this.status < 400) schedule(); }); } catch (e) {}
      return XO.apply(this, arguments);
    };
  }

  if (document.readyState == 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
